import axios from "axios";
import Cookies from "universal-cookie";

const getMatterData = async () => {
  try {
    const token = new Cookies().get("portal-token");

    const response = await axios.post(
      "https://api.portal.equilaw.uk.com/Matters/GetMatterData",
      { token: token }
    );

    return response.data;
  } catch (err) {
    console.error(err);
  }
};

export default getMatterData;
